import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Box, ThemeProvider, CssBaseline } from "@mui/material";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { PublicHeader } from "@/components/public/PublicHeader.tsx";
import { PublicFooter } from "@/components/public/PublicFooter.tsx";
import { publicTheme } from "@/style/publicTheme.ts";

const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string;

export const Route = createFileRoute("/_public")({
  component: PublicLayoutComponent,
});

function PublicLayoutComponent() {
  return (
    <ThemeProvider theme={publicTheme}>
      <CssBaseline />
      <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
            bgcolor: "background.default",
          }}
        >
          <PublicHeader />
          <Box component="main" sx={{ flexGrow: 1 }}>
            <Outlet />
          </Box>
          <PublicFooter />
        </Box>
      </GoogleReCaptchaProvider>
    </ThemeProvider>
  );
}
